import { defineComponent as E, computed as v, createElementBlock as p, openBlock as n, normalizeClass as L, unref as l, createBlock as i, createCommentVNode as d, Fragment as f, renderList as j } from "vue";
import { useMediaQuery as M } from "@vueuse/core";
import { useRoute as V } from "vue-router";
import { useColorMode as D } from "@scalar/use-hooks/useColorMode";
import { DocumentClasses as S } from "@scalar-org/css";
import _ from "./HeaderLogoutButton.vue.js";
import $ from "./HeaderItemGroup.vue.js";
import H from "./HeaderItemLink.vue.js";
import N from "./HeaderItemMeta.vue.js";
import O from "./HeaderItemSpacer.vue.js";
import w from "./HeaderItemTab.vue.js";
import A from "./HeaderItemVersionSelect.vue.js";
const W = /* @__PURE__ */ E({
  __name: "DocumentHeader",
  props: {
    project: {},
    versions: {},
    activeVersion: {},
    activeUids: {},
    activeGuide: {},
    headerLinks: {},
    isEditable: { type: Boolean },
    resolveInternalLinks: { type: Function }
  },
  emits: ["selectVersion", "navigate", "setSidebar", "toggleShow", "editOpenAPIDocument"],
  setup(k, { emit: g }) {
    const t = k, a = g, m = V(), { isDarkMode: y } = D(), b = v(() => y.value ? t.project.logo.darkMode : t.project.logo.lightMode), s = M("(max-width: 1000px)"), I = v(() => {
      const e = [...t.headerLinks];
      return s.value ? e.sort((o) => o.type === "version-selector" ? -1 : 1).filter((o) => o.type !== "spacer") : e;
    });
    function u(e, o) {
      a("navigate", o, e), s.value && a("setSidebar", !1);
    }
    function h(e, o) {
      a("toggleShow", e, o);
    }
    function c(e) {
      return t.activeUids?.includes(e.uid) || e.uid === m.name || e.uid === t.activeGuide || Object.values(m.params).includes(e.uid) ? !0 : e.type === "group" ? e.children.some((o) => c(o)) : !1;
    }
    return (e, o) => (n(), p("header", {
      class: L(["header", l(S).Header])
    }, [
      l(s) ? d("", !0) : (n(), i(N, {
        key: 0,
        logo: b.value,
        primaryVersionUid: e.project.activeVersionId,
        projectName: e.project.name
      }, null, 8, ["logo", "primaryVersionUid", "projectName"])),
      (n(!0), p(f, null, j(I.value, (r) => (n(), p(f, {
        key: r.uid
      }, [
        r.type === "group" ? (n(), i($, {
          key: 0,
          group: r,
          isEditable: !!e.isEditable,
          isMobile: l(s),
          linkIsActive: c,
          resolveInternalLinks: e.resolveInternalLinks,
          onNavigate: u
        }, null, 8, ["group", "isEditable", "isMobile", "resolveInternalLinks"])) : r.type === "guide" || r.type === "reference" ? (n(), i(w, {
          key: 1,
          isEditable: !!e.isEditable,
          isMobile: l(s),
          linkIsActive: c,
          resolveInternalLinks: e.resolveInternalLinks,
          tab: r,
          onEditOpenAPIDocument: (C) => a("editOpenAPIDocument", r.uid),
          onNavigate: u,
          onToggleShow: h
        }, null, 8, ["isEditable", "isMobile", "resolveInternalLinks", "tab", "onEditOpenAPIDocument"])) : r.type === "link" ? (n(), i(H, {
          key: 2,
          link: r
        }, null, 8, ["link"])) : r.type === "spacer" ? (n(), i(O, { key: 3 })) : r.type === "version-selector" && Object.keys(e.versions).length > 1 ? (n(), i(A, {
          key: 4,
          activeVersion: e.activeVersion,
          versions: e.versions,
          onNavigate: u
        }, null, 8, ["activeVersion", "versions"])) : d("", !0)
      ], 64))), 128)),
      e.project.isPrivate && !e.isEditable ? (n(), i(_, { key: 1 })) : d("", !0)
    ], 2));
  }
});
export {
  W as default
};
